import React,{useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import trophy from '../../assets/exam/trophy.png'
import fail from '../../assets/exam/fail.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faArrowUp } from '@fortawesome/free-solid-svg-icons'




const ShowAnswer = React.memo( props =>{
let navigate = useNavigate();
const [visible, setVisible] = useState(false)
const [show, setShow] = useState(true);
const handleClose = () => setShow(false);
// Destructuring

const {questions,exam,score,queslength} = props;






function handleCertificate() {
        navigate('/certificate', {
            state: {
                exam: exam,
                percentage: (Math.floor((score / queslength) * 100)),
            }
        });
};

// function handleRestart() {
//     props.onReload();
//   }

const handleRestart = () => window.location.reload(true);

useEffect(()=>{
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        scrolled > 300 ? setVisible(true) : setVisible(false)
      };
      window.addEventListener('scroll', toggleVisible);

      return () =>{
        window.removeEventListener('scroll', toggleVisible);
      }

},[]);

const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };
  

return (
    <div >
 <Modal show={show} centered >
      
        <Modal.Body className=' pt-4'>
            <div className='container text-center'>
                <h4>Your Result</h4>
               
                {(Math.floor((score / queslength) * 100) >= 80) ? 
                <>  <img src={trophy} alt="trophy" width="150px" height="150px" />
                    <h5 id="result" style={{ color: "green" }}>Congratulations</h5> </>
                    :
                    <>
                    <img src={fail} alt="fail" width="150px" height="150px" />
                     <h5 id="result" className="mt-2" style={{ color: "#272274" }}>Try to Improve your Skills</h5>
                    </>
                   }
                <p className='mt-2 mb-0 pb-0'>Correct Answer : <b>{score} out of {queslength}</b></p>
                <p>Your Score is : <b>{Math.floor((score / queslength) * 100)}%</b></p>
            </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center pb-4 pt-0 "
        style={{borderTop:"0px"}}>
            {(Math.floor((score / queslength) * 100) >= 80) ?
                <div>
                    <button className="btn btn-outline-success mx-2 exam-btn" onClick={() => handleCertificate()}>Get Certificate</button>
                    <button className="btn btn-outline-primary exam-btn" onClick={handleRestart}>Restart</button>
                </div> :
                <div className="text-center">
                    <button className="btn btn-outline-primary exam-btn" onClick={handleRestart}>Restart</button>
                </div>
            }

            <div className="text-end">
                <button className="btn btn-info exam-btn" onClick={handleClose}>Show Answer</button>
            </div>
        </Modal.Footer>
    </Modal>

{/* =====================Show all question and answer =====================*/}

    <div className='d-flex align-items-center  justify-content-between px-3 py-2 py-sm-0 mb-3 flex-wrap'
        style={{
            backgroundColor: "#ddd1e71c",
            borderRadius: "5px",
               }}>
       
                <h3 className='text-capitalize'>{exam.name}</h3>
       
        
        {/*====================== buttons =================*/}
        <div >
            {(Math.floor((score / queslength) * 100) >= 80)?
                <div className="my-3">
                    <button className="btn btn-outline-success mx-2 exam-btn" onClick={() => handleCertificate()}>Get Certificate</button>
                </div>:
                <div className="my-3 ">
                    <button className="btn btn-outline-primary me-2 exam-btn" onClick={handleRestart}>Restart</button>
                    <button className="btn btn-outline-secondary exam-btn" onClick={() => {navigate('/skill-test')}}>Go Back</button>
                </div>
            }
        </div>

    </div>
    {questions.map((item, index) => {
        return (
            <div key={item.question}>
                <h6>Q{index + 1 + ") "}{item.question}</h6>
                <div>
                          
                    <ol type="a" className='qstns' >
                        {item.options.map((opt, optIndex) => {
                            return (
                                
                           
                                <li key={optIndex} className='py-1' >
                                    <span className= { opt.id === item.answer ?"correctAns":""}>
                                    {opt.option}
                                    </span>
                                   </li>
                          
                            )
                        })}
                    </ol>
                </div>
                {/* <h6 style={{
                    backgroundColor: "#e2f6f9",
                    display: "inline-block",
                    padding: "8px 14px",
                    borderRadius: "5px",
                }}>
                        Answer : {item.answer}</h6> */}
                <h6
                    style={{
                        display: "block",
                        backgroundColor: "#e9eafb",
                        padding: "22px 14px",
                        marginTop: "5px",
                        borderRadius: "5px",
                        lineHeight:"1.5"
                    }}
                >Explain: <span className="fw-normal">{item.explain}</span></h6>
                <hr />
            </div>)
    })}
    
        <button className='top-btn'  onClick={scrollToTop}  style={{display: visible ? 'inline' : 'none'}}>
                <FontAwesomeIcon icon={faArrowUp} style={{color: "#ffffff",}} />
        </button>
    </div>
  )
        
});


export default ShowAnswer;